import axiosInstance from './Instance/axiosInstance';

export const fetchDashboardSummary = async () => {
    const response = await axiosInstance.get('/dashboard/summary');
    return response.data;
};
